import styled from 'styled-components'

const CategoryFilterStyle = styled.div`
	--categoryItemPadding: var(--sp1-5x) var(--sp4x);
	--categoryItemMarginRight: var(--sp3x);

	.filters-wrap {
		padding-left: var(--contPaddingLR);
		padding-right: var(--contPaddingLR);

		&::-webkit-scrollbar {
			display: none;
			-ms-overflow-style: none;
			scrollbar-width: none;
		}

		.filters-inner-wrap {
			display: flex;
			flex-wrap: wrap;
			width: 100%;
			white-space: nowrap;
			padding-right: var(--categoryItemMarginRight);
			margin-top: calc(var(--categoryItemMarginRight) * -1);

			.category-item {
				padding: var(--categoryItemPadding);
				border: 1px solid var(--textBlack100);
				border-radius: var(--sp15x);
				margin-right: var(--categoryItemMarginRight);
				margin-top: var(--categoryItemMarginRight);
				cursor: pointer;

				&.active {
					border: 1px solid var(--green100);
					background-color: var(--green100);

					.category-name {
						color: var(--white);
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--categoryItemPadding: var(--sp1x) var(--sp3x);
		--categoryItemMarginRight: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--categoryItemPadding: var(--sp1x) var(--sp3x);
		--categoryItemMarginRight: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--categoryItemPadding: var(--sp1x) var(--sp3x);
		--categoryItemMarginRight: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--categoryItemPadding: var(--sp1x) var(--sp2x);
		--categoryItemMarginRight: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--categoryItemPadding: var(--sp1x) var(--sp2x);
		--categoryItemMarginRight: var(--sp2x);

		.filters-wrap {
			overflow: scroll hidden;
			padding-right: unset;

			.filters-inner-wrap {
				flex-wrap: nowrap;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--categoryItemPadding: var(--sp1x) var(--sp2x);
		--categoryItemMarginRight: var(--sp2x);

		.filters-wrap {
			overflow: scroll hidden;
			padding-right: unset;

			.filters-inner-wrap {
				flex-wrap: nowrap;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--categoryItemPadding: var(--sp1x) var(--sp2x);
		--categoryItemMarginRight: var(--sp2x);

		.filters-wrap {
			overflow: scroll hidden;
			padding-right: unset;

			.filters-inner-wrap {
				flex-wrap: nowrap;
			}
		}
	}
`

export default CategoryFilterStyle
